export const getMajorResultBackPath = (
  isStaffView: boolean,
  beneficiaryUserId?: number | null,
) => {
  if (!isStaffView || !beneficiaryUserId) {
    return undefined;
  }

  return `/admin/resultat-beneficiaire/${beneficiaryUserId}`;
};
